import axios from "axios";
import {getAuthCode} from "../login/auth"
import {getHost} from "../login/auth"

export default async function deleteRequest(id) {
  try {
    let response = await axios({
        url: getHost() + "/feed",
        method: 'delete',
        headers: {'Authorization': getAuthCode()},
        data: {
          id: id
        }
    })
    return response
  } catch (error) {
    return { error };
  }
}
